import { Injectable, inject } from '@angular/core';
import { ISelector } from '@bdeo-platform/private-api';
import { ApiClientService } from './api-client.service';

@Injectable({
  providedIn: 'root'
})
export class SelectorService {
  private readonly apiClientService = inject(ApiClientService);
  private selectors: { [k: string]: ISelector[] | { [key: string]: unknown } | Promise<ISelector[] | { [key: string]: unknown }> } = {};

  public async get<T>(name: string): Promise<{ [key: string]: ISelector & T } & (ISelector & T)[]> {
    let selector = this.selectors[name];

    if (!selector) {
      this.selectors[name] = selector = this.getSelector(name);
    }

    if (selector instanceof Promise) {
      selector = await selector;
    }

    return selector as { [key: string]: ISelector & T } & (ISelector & T)[];
  }

  private async getSelector(name: string): Promise<ISelector[] | { [key: string]: unknown }> {
    try {
      const response = await this.apiClientService.getApiClient().motor.shared.selector.get({ type: name });

      const {
        data: { success, items }
      } = response;

      if (!success) {
        // TODO handle a not success call
      }

      return items;
    } catch (e: unknown) {
      console.warn('Error: ', e);
      if (e instanceof this.apiClientService.getApiClient().motor.shared.selector.get.Error) {
        const error = e.getActualType();

        if (error.status === 400) {
          // TODO handle 400
        }
      }

      throw e;
    }
  }
}
